// 12px height separator
import React from "react"
import PropTypes from "prop-types"
import "./Separator.scss"

type SeparatorProps = {
  marginTop: number
  marginBottom: number
  className: string
}

const Separator = ({ marginTop = 0, marginBottom = 0, className }: SeparatorProps) => {
  return (
    <div
      className={`prime-separator${className ? " " + className : ""}`}
      style={{
        marginTop,
        marginBottom,
      }}
    >
      .....
    </div>
  )
}

Separator.propTypes = {
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
}

export default Separator
